import { Box, Typography } from "@mui/material";
import { palette } from "../../theme";
import MessageRenderer from "./message-renderer";

interface Message {
  sender: string;
  text: string;
  imageUrls?: string[];
}

export const MessageBox = ({
  message,
  index,
}: {
  message: Message;
  index: number;
}) => {
  const isUser = message.sender === "User";
  
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isUser ? "flex-start" : "flex-end",
        width: "100%",
        marginBottom: 1.5,
        animation: "fadeIn 0.3s ease-out",
        "@keyframes fadeIn": {
          "0%": {
            opacity: 0,
            transform: "translateY(10px)",
          },
          "100%": {
            opacity: 1,
            transform: "translateY(0)",
          },
        },
      }}
    >
      <Box
        sx={{
          color: isUser ? palette.white : palette.purple,
          borderRadius: "16px",
          backgroundColor: isUser ? palette.purple : palette.purple_light,
          padding: "12px 16px",
          wordBreak: "break-word",
          maxWidth: "80%",
          borderTopRightRadius: isUser ? "4px" : "16px",
          borderTopLeftRadius: isUser ? "16px" : "4px",
          transition: "all 0.2s ease",
          "&:hover": {
            transform: "translateY(-1px)",
          },
        }}
      >
        {message.imageUrls && message.imageUrls.length > 0 && (
          <Box
            sx={{
              marginBottom: message.text ? 2 : 0,
              display: 'flex',
              // flexDirection: 'column',
              gap: 1,
            }}
          >
            {message.imageUrls.map((imageUrl, idx) => (
              <Box
                key={idx}
                sx={{
                  borderRadius: "8px",
                  overflow: "hidden",
                  maxWidth: "100%",
                  border: "1px solid #ccc",
                }}
              >
                <img
                  src={imageUrl}
                  alt={`Uploaded content ${idx + 1}`}
                  style={{
                    width: "100%",
                    maxHeight: "300px",
                    objectFit: "contain",
                  }}
                />
              </Box>
            ))}
          </Box>
        )}
        <Typography 
          variant="body2"
          sx={{
            lineHeight: 1.5,
            fontSize: "0.95rem",
          }}
        >
          <MessageRenderer text={message.text} />
        </Typography>
      </Box>
    </Box>
  );
};
